"use client";

import { useEffect, useState } from "react";
import LoadingScreenDenda from "../Unique/Animation/loading_screen";
import { get } from "../../lib/api";

const PageStatisticsHeader = ({ game_id }) => {
  const [gameplays, setGameplays] = useState([0, 0, 0, 0]);
  const [ads, setAds] = useState([0, 0, 0, 0]);
  const [loading, setLoading] = useState(true);
  const [uniqueUsers, setUniqueUsers] = useState([0, 0, 0, 0]);

  useEffect(() => {
    const ensureNumber = (value) => (isNaN(value) || value == null ? 0 : value);

    const fetchData = async () => {
      if (!game_id) return;
      setLoading(true);

      const data = await get(`/statistics?method=getHeaderStatisticsNew&gameid=${game_id}`);
      const ads_this_month = ensureNumber(Number.parseInt(data["Ads Current Month"])) + ensureNumber(Number.parseInt(data["Ads Today"]));
      const gp_this_month = ensureNumber(Number.parseInt(data["Gameplays Current Month"])) + ensureNumber(Number.parseInt(data["Gameplays Today"]));
      const uu_this_month = ensureNumber(Number.parseInt(data["Unique Users Current Month"])) + ensureNumber(Number.parseInt(data["Unique Users Today"]));

      setGameplays([
        ensureNumber(data["Gameplays Today"]),
        ensureNumber(data["Gameplays Yesterday"]),
        gp_this_month,
        ensureNumber(data["Gameplays Last Month"]),
      ]);

      setAds([
        ensureNumber(data["Ads Today"]),
        ensureNumber(data["Ads Yesterday"]),
        ads_this_month,
        ensureNumber(data["Ads Last Month"]),
      ]);

      setUniqueUsers([
        ensureNumber(data["Unique Users Today"]),
        ensureNumber(data["Unique Users Yesterday"]),
        uu_this_month,
        ensureNumber(data["Unique Users Last Month"]),
      ]);

      setLoading(false);
    };

    fetchData();
  }, [game_id]);

  if (loading) {
    return <LoadingScreenDenda text="Loading..." />;
  }

  return (
    <div style={{width: '87.5vw'}}>
      <div className="w-full bg-[#ffffff] text-black rounded-lg p-4 dark:bg-[#232833] dark:text-[#f3f4f6]">
        {/* Metrics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4 w-full">
          {[
            { label: "Gameplay Today", value: gameplays[0] },
            { label: "Gameplay Yesterday", value: gameplays[1] },
            { label: "Gameplay This Month", value: gameplays[2] },
            { label: "Gameplay Previous Month", value: gameplays[3] },
            { label: "Ads Today", value: ads[0] },
            { label: "Ads Yesterday", value: ads[1] },
            { label: "Ads This Month", value: ads[2] },
            { label: "Ads Previous Month", value: ads[3] },
            { label: "Unique Users Today", value: uniqueUsers[0] },
            { label: "Unique Users Yesterday", value: uniqueUsers[1] },
            { label: "Unique Users This Month", value: uniqueUsers[2] },
            { label: "Unique Users Previous Month", value: uniqueUsers[3] },
          ].map((metric, index) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center bg-[#f3f4f6] rounded-lg p-6 transition-transform transform  shadow-md dark:bg-[#2c313c] h-20"
            >
              <h2 className="text-xs md:text-sm uppercase font-bold text-[#232833] mb-1 tracking-wide dark:text-[#cfd2d6]">{metric.label}</h2>
              <p className="text-2xl font-bold text-[#232833] tracking-wide dark:text-[#f3f4f6]">{metric.value ? Intl.NumberFormat("de-DE").format(metric.value) : "..."}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageStatisticsHeader;
